import {defineField} from 'sanity'

export default [
  defineField({
    name: 'url',
    title: 'URL',
    type: 'string',
  }),
]
